export const useProductActionsManagement = () => {
  const storeSubscription = useProductSubscriptionStore()
  const { customerHandle } = useUserStore()
  const shoppingListStore = useShoppingList()
  const { addOrUpdateItem, deleteItem } = useCartActions()
  const alternativeCustomSourceUrl = inject<ComputedRef<string | null>>('alternativeCustomSourceUrl', computed(() => null))

  async function updateQuantity(supplierHandle: string, productHandle: string, reference: string, newQuantity: number, originalQuantity: number, trackingCtx?: { index?: number, pageSection?: string }) {
    if (newQuantity === 0) {
      const success = await deleteItem(
        supplierHandle,
        productHandle,
        reference.toUpperCase(),
        true,
        trackingCtx,
      )
      return success
    }

    const isNewItem = originalQuantity === 0 && newQuantity > 0
    const source = alternativeCustomSourceUrl.value || location.href
    const success = await addOrUpdateItem(
      supplierHandle,
      {
        handle: productHandle,
        quantity: newQuantity,
        reference: reference.toUpperCase() as 'OFFICE' | 'PHARMACY',
        source,
      },
      isNewItem,
      trackingCtx,
    )
    return success
  }

  async function updateReminder(productHandle: string, isSubscribed: boolean): Promise<boolean> {
    if (isSubscribed) {
      await storeSubscription.delete(customerHandle!, productHandle)
    }
    else {
      await storeSubscription.create(customerHandle!, productHandle)
    }
    return !isSubscribed
  }

  async function faveUpdate(newValue: boolean, productHandle: string, isFavourite: boolean) {
    if (isFavourite) {
      await shoppingListStore.removeFromShoppingList([productHandle])
    }
    return newValue
  }

  return {
    updateQuantity,
    updateReminder,
    faveUpdate,
  }
}
